define('modules/accounts/view',['require','exports','module','views/BaseView','env','ProductsHelper','ldsh!./template'],function (require, exports, module) {
  "use strict";

  var BaseView = require("views/BaseView"),
    Config = require("env"),
    ProductsHelper = require("ProductsHelper");

  var Main = BaseView.extend({
    template: require("ldsh!./template"),

    initialize: function () {
      this.checkLocation();
    },

    serialize: function () {
      var viewParams = {
        activeTab: this.activeTab,
        model: this.model,
        linkGruopId: this.options.linkGruopId,
        allowSecurityOptionsByGroup: this.checkAllowSecurityOptionsByGroup(),
        groupId: this.model.getGroup(),
        groupName: this.group.get("name") || this.model.getName(),
        productIdLabel: ProductsHelper.getProductLabelFromId(
          this.group.get("productId")
        ),
      };

      return viewParams;
    },

    checkLocation: function () {
      switch (window.location.pathname) {
        case "/accounts/status":
        case "/accounts":
          this.pushTag("/cuentas/estado");
          break;
        case "/accounts/user/me":
          this.pushTag("/cuentas/miperfil");
          break;
        case "/accounts/users":
          this.pushTag("/cuentas/usuarios");
          break;
        case "/accounts/companies":
          this.pushTag("/cuentas/subcuentas");
          break;
      }
    },

    pushTag: function (url) {
      $.tagManager("push", {
        virtualurl: url,
        event: "virtualpage",
      });
    },

    checkAllowSecurityOptionsByGroup: function () {
      return (
        Config.securityOptionsAllowGroups.length === 0 ||
        $.inArray(
          parseInt(this.model.getGroup()),
          Config.securityOptionsAllowGroups
        ) !== -1
      );
    },
  });

  module.exports = Main;
});

